<template>
  <div class="remindadd">
    <van-field v-model="name" label="客户" readonly />
    <div role="button" tabindex="0" class="van-cell van-cell--clickable" @click="showTimeEvemt">
      <div style="width: 100px;"><span>提醒时间</span></div>
      <!-- <div class="van-cell__value" style="text-align: left;"><span>请选择提醒时间</span></div> -->
      <div class="van-cell__value" style="text-align: left;color: #323233;"><span>{{noticeTime | dateFormat}}</span></div>
      <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
    </div>
    <van-field v-model="content" rows="3" autosize label="提醒内容" type="textarea" maxlength="200" placeholder="请输入提醒内容" show-word-limit/>
    <van-popup v-model="isShow" position="bottom" :close-on-click-overlay='false'>
      <van-datetime-picker v-model="currentDate" type="datetime" :min-date="minDate" :max-date="maxDate" @confirm="confirmEvemt" @cancel="cancelEvemt" />
    </van-popup>
    <div style="margin: 50px 16px;background: #FFFFFF;">
      <van-button round block type="info" native-type="submit" @click="addEvemt">保存</van-button>
    </div>
  </div>
</template>
<script>
import { customerfollowupnoticecreate } from '@/api/remind'
export default {
  data() {
    return {
      customerId: Number(this.$route.query.customerId),
      name: this.$route.query.name || '',
      minDate: new Date(),
      maxDate: new Date(2055, 10, 1),
      currentDate: new Date(),
      isShow: false,
      noticeTime: parseInt(((new Date()).getTime()) / 1000),
      content: ''
    }
  },
  created() {
  },
  methods: {
    showTimeEvemt() {
      this.currentDate = new Date((this.noticeTime * 1000))
      this.isShow = true
    },
    confirmEvemt(val) {
      this.noticeTime = parseInt((val.getTime()) / 1000)
      this.isShow = false
    },
    cancelEvemt() {
      this.isShow = false
    },
    addEvemt() {
      if (!this.content) return this.$toast('请输入提醒内容')
      customerfollowupnoticecreate({
        customerId: this.customerId,
        noticeTime: this.noticeTime,
        content: this.content
      }).then(res => {
        if (res.errcode === 0) {
          this.$toast.success('保存成功');
          this.$router.go(-1)
        }
      });
    }
  }
}
</script>
<style>
.main-page{
  min-height: 100% !important;
}
</style>
<style lang="less" scoped>
.remindadd {
  background: #ffffff;
  height: 100%;
}
</style>